import { jsx as t } from "@emotion/react/jsx-runtime";
import r from "@mui/material/TextField";
const i = ({ ...e }) => /* @__PURE__ */ t(r, { ...e });
i.displayName = "TextField";
export {
  i as T
};
